import axios from "axios"
// import qs from "qs"
import store from "@/store"
// import storage from "store"
import {Message} from 'element-ui'
import router from "../router"
import OrderPay from "../utils/modal"
import {hideLoading, showLoading} from "./show-loading";

//create an axios instance
const service = axios.create({
    // baseURL: window.location.href.indexOf('wudi')==-1? "http://xxz-api-t.smarlife.cn/" : "http://wudizn.smarlife.cn/",
    //baseURL: "https://wxapiback.seaquire.com/api",
    baseURL: "https://repository.1-2315.com/api",
    // baseURL: window.location.protocol + '//' + window.location.host + '/api',
    //baseURL: " http://localhost:8000/api",
    //send cookies when cross-domain requests
    // withCredentials: true
    timeout: 12000
})

//request interceptor
service.interceptors.request.use(
    config => {
        showLoading(true)
        let token = store.state.user.token
        config.headers["Authorization"] = 'Bearer ' + token
        config.headers["x-business"] = store.state.business

        // if (config.method == 'POST') {
        config.headers["Content-Type"] = "application/json"
        // config.headers["Content-Type"] = "application/x-www-form-urlencoded"
        // if( config.method == 'POST'){
        //     config.data = JSON.stringify(config.data)
        // }else{
        //     config.data = qs.stringify(config.data)
        // }
        // }

        return config
    },
    error => {
        //do sth when req error
        hideLoading()
        Message.warn(error)
        return Promise.reject(error)
    }
)

//response interceptor
service.interceptors.response.use(
    response => {
        hideLoading()
        // console.log(response)
        const {code, msg, data} = response.data
        if (code === 1) {
            Message.error(msg)
            return Promise.reject(Error(msg))
        }
        if (code === 0) {
            return Promise.resolve(data)
        }
        if (code != 200 & code != 403) {
            if (msg != '') {
                Message.error(msg)
            }
            if (code == -400207) {
                OrderPay.install(data);
            }
        }
        if (code == 403) {
            Message.success("登录失效");
            store.commit("setUser", "");
            setTimeout(() => {
                router.push("/");
            }, 200);
        }
        return Promise.resolve(response.data)
    },
    error => {
        hideLoading()
        // console.log(error)
        // if (error.response) {
        //   const { status } = error.response
        //   // const token = storage.get(ACCESS_TOKEN)
        //   // 有token但鉴权失败
        //   // && token
        //   if (status === 401) {
        //     store.dispatch("LogOut").then(() => {
        //       setTimeout(() => {
        //         router.push({ name: "index" })
        //       }, 1000)
        //     })
        //   } else {
        //     Message.error(error.message)
        //   }
        // }
        return Promise.reject(error)
    }
)

//get
export function Get(url, config = {showLoading: true, params: {}}) {
    return service.get(url, config)
}

//post
export function Post(url, data) {
    return service.post(url, data)
}

//put
export function Put(url, data) {
    return service.put(url, data)
}

//delete
export function Delete(url, data) {
    return service.delete(url, {
        data: data
    })
}

const request = service
export default request